import { plural, t } from '@lingui/macro';
import i18n from 'config/i18n';

export const Months = [
  i18n._(`January`),
  i18n._(`February`),
  i18n._(`March`),
  i18n._(`April`),
  i18n._(`May`),
  i18n._(`June`),
  i18n._(`July`),
  i18n._(`August`),
  i18n._(`September`),
  i18n._(`October`),
  i18n._(`November`),
  i18n._(`December`),
];

const intervals = [
  { label: 'year', seconds: 31536000 },
  { label: 'month', seconds: 2592000 },
  { label: 'day', seconds: 86400 },
  { label: 'hour', seconds: 3600 },
  { label: 'minute', seconds: 60 },
  { label: 'second', seconds: 0 },
];

/**
 * Receives a number of seconds and return
 * them as time format: 00:00
 * @param {Number} seconds 
 */
export function formatSeconds(seconds) {
  let sec = seconds > 59 ? Math.ceil(seconds % 60) : Math.ceil(seconds);
  const mins = sec === 60 ? Math.ceil(seconds / 60) : Math.trunc(seconds / 60);
  const hours = Math.trunc(mins / 60);
  sec = sec === 60 ? 0 : sec;

  if (hours > 0) {
    return `${hours > 9 ? hours : `0${hours}`}:${mins > 9 ? mins : `0${mins}`}:${sec > 9 ? sec : `0${sec}`}`;
  }

  if (mins > 0) {
    return `${mins > 9 ? mins : `0${mins}`}:${sec > 9 ? sec : `0${sec}`}`;
  }

  if (sec > 0) {
    return `00:${sec > 9 ? sec : `0${sec}`}`;
  }

  return '00:00';
}

/**
 * Receives a string in the form of `00:00:00` that
 * represents the duration of the song. This function checks
 * if the duration is longer than an hour, if not it will
 * remove the first two zeros.
 * @param {String} duration 
 */
export function formatDuration(duration) {
  if (duration && duration[0] === '0' && duration[1] === '0') {
    return duration.substring(3);
  }

  return duration;
}

export function timeAgo(value) {
  if (!value) return '';

  let date = new Date(value);

  // For unix time dates
  if (typeof value === 'number') {
    date = new Date(value);
  }

  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  const interval = intervals.find(i => i.seconds <= seconds);

  if (interval === undefined) {
    return '';
  }

  if (interval.seconds === 0) {
    return i18n._(t`just now`);
  }

  const count = Math.floor(seconds / interval.seconds);
  switch (interval.label) {
    case 'year':
      return i18n._(plural({ value: count, one: "# year ago", other: "# years ago" }));
    case 'month':
      return i18n._(plural({ value: count, one: "# month ago", other: "# months ago" }));
    case 'day':
      return i18n._(plural({ value: count, one: "# day ago", other: "# days ago" }));
    case 'hour':
      return i18n._(plural({ value: count, one: "# hour ago", other: "# hours ago" }));
    case 'minute':
      return i18n._(plural({ value: count, one: "# minute ago", other: "# minutes ago" }));
    case 'second':
      return i18n._(plural({ value: count, one: "# second ago", other: "# seconds ago" }));
  }

  return '';
}

/**
 * Checks if the given date is valid or not
 * @param {Date} date 
 */
export function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}

/**
 * recives a string date right from the database and converts it to
 * a short date/time string.
 */
export function dateTime(input) {
  const date = new Date(input);

  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
}
